"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BodyLarge", {
  enumerable: true,
  get: function () {
    return _Text.BodyLarge;
  }
});
Object.defineProperty(exports, "BodyLargeBold", {
  enumerable: true,
  get: function () {
    return _Text.BodyLargeBold;
  }
});
Object.defineProperty(exports, "BodyMedium", {
  enumerable: true,
  get: function () {
    return _Text.BodyMedium;
  }
});
Object.defineProperty(exports, "BodyMediumBold", {
  enumerable: true,
  get: function () {
    return _Text.BodyMediumBold;
  }
});
Object.defineProperty(exports, "BodySmall", {
  enumerable: true,
  get: function () {
    return _Text.BodySmall;
  }
});
Object.defineProperty(exports, "BodySmallBold", {
  enumerable: true,
  get: function () {
    return _Text.BodySmallBold;
  }
});
Object.defineProperty(exports, "ButtonTextExtraSmall", {
  enumerable: true,
  get: function () {
    return _Text.ButtonTextExtraSmall;
  }
});
Object.defineProperty(exports, "ButtonTextExtraSmallUnderline", {
  enumerable: true,
  get: function () {
    return _Text.ButtonTextExtraSmallUnderline;
  }
});
Object.defineProperty(exports, "ButtonTextMedium", {
  enumerable: true,
  get: function () {
    return _Text.ButtonTextMedium;
  }
});
Object.defineProperty(exports, "ButtonTextMediumUnderline", {
  enumerable: true,
  get: function () {
    return _Text.ButtonTextMediumUnderline;
  }
});
Object.defineProperty(exports, "ButtonTextSmall", {
  enumerable: true,
  get: function () {
    return _Text.ButtonTextSmall;
  }
});
Object.defineProperty(exports, "ButtonTextSmallUnderline", {
  enumerable: true,
  get: function () {
    return _Text.ButtonTextSmallUnderline;
  }
});
Object.defineProperty(exports, "FormInputMedium", {
  enumerable: true,
  get: function () {
    return _Text.FormInputMedium;
  }
});
Object.defineProperty(exports, "FormInputSmall", {
  enumerable: true,
  get: function () {
    return _Text.FormInputSmall;
  }
});
Object.defineProperty(exports, "FormLabelMedium", {
  enumerable: true,
  get: function () {
    return _Text.FormLabelMedium;
  }
});
Object.defineProperty(exports, "FormLabelSmall", {
  enumerable: true,
  get: function () {
    return _Text.FormLabelSmall;
  }
});
Object.defineProperty(exports, "JumboLarge", {
  enumerable: true,
  get: function () {
    return _Text.JumboLarge;
  }
});
Object.defineProperty(exports, "JumboMedium", {
  enumerable: true,
  get: function () {
    return _Text.JumboMedium;
  }
});
Object.defineProperty(exports, "JumboSmall", {
  enumerable: true,
  get: function () {
    return _Text.JumboSmall;
  }
});
Object.defineProperty(exports, "SubTitleExtraSmall", {
  enumerable: true,
  get: function () {
    return _Text.SubTitleExtraSmall;
  }
});
Object.defineProperty(exports, "SubTitleLarge", {
  enumerable: true,
  get: function () {
    return _Text.SubTitleLarge;
  }
});
Object.defineProperty(exports, "SubTitleMedium", {
  enumerable: true,
  get: function () {
    return _Text.SubTitleMedium;
  }
});
Object.defineProperty(exports, "SubTitleSmall", {
  enumerable: true,
  get: function () {
    return _Text.SubTitleSmall;
  }
});
Object.defineProperty(exports, "TEXT_COLORS", {
  enumerable: true,
  get: function () {
    return _typography.TEXT_COLORS;
  }
});
Object.defineProperty(exports, "TitleMedium", {
  enumerable: true,
  get: function () {
    return _Text.TitleMedium;
  }
});
var _typography = require("../../types/typography");
var _Text = require("./Text");